import { VertSpacerSm } from '@apps-common/components/layout'

export const UnitPlanCardSkeleton = () => (
  <div>
    <div className='p-6 w-full rounded-3xl bg-skeleton border border-skeleton-border animate-pulse'>
      <div className='flex items-center justify-end gap-[5px]'>
        <div className='avatar'>
          <div className='!flex w-7 items-center justify-center rounded-full bg-skeleton-hi' />
        </div>
        <div className='avatar'>
          <div className='!flex w-7 items-center justify-center rounded-full bg-skeleton-hi' />
        </div>
      </div>
      <div className='bg-skeleton-hi w-[50%] h-[20px] rounded-[10px]' />
      <VertSpacerSm />
      <div className='bg-skeleton-hi w-[80%] h-[20px] rounded-[10px]' />
    </div>
  </div>
)
